import { server_ip } from "../config";

async function postRiskAssessmentTemplateData(token,data) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessmentTemplates/`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function putRiskAssessmentTemplateData(token,data,_id) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessmentTemplates/${_id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function deleteRiskAssessmentTemplate(token,_id) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessmentTemplates/${_id}`, {
            method: 'DELETE',
            headers: {
                Accept: '/',
                Authorization: `Bearer ${token}`,
            },
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function postRiskAssessmentTemplateDocument(token,file,id,type) {
    console.log(file, id)
    let formData = new FormData();
    formData.append('file', file[1]);
    try {
        const response = await fetch(`${server_ip}/api/documents/upload`, {
            method: 'POST',
            headers: {
                'isriskassessmentdocument': 'true',
                'riskAssessmentDocumentId': id,
                filetype:type,
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function fetchRiskAssessmentTemplateList(token, filter={}, options={}) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessmentTemplates/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
async function deleteRiskAssessment(token,_id) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessments/${_id}`, {
            method: 'DELETE',
            headers: {
                Accept: '/',
                Authorization: `Bearer ${token}`,
            },
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function postCreateRiskAssessment(token,data) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessments/`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function putEditRiskAssessment(token,data,_id) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessments/${_id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function fetchRiskAssessment(token, filter={}, options={}) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessments/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function fetchRiskAssessmentById(token,id) {
    try {
        const response = await fetch(`${server_ip}/api/riskAssessments/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function postRiskAssessmentHistory(token, data){
    try {
        const response = await fetch(`${server_ip}/api/riskAssessmentHistory/`,{
            method:'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,    
            },
            body: JSON.stringify({
                data
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function fetchRiskAssessmentHistory(token,_id){
    try {
        const response = await fetch(`${server_ip}/api/riskAssessmentHistory/fetch  `,{
            method:'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',  
                Authorization: `Bearer ${token}`,    
 
            },
            body: JSON.stringify({
                "filter":{"riskAssessment_id":_id},
                "options":{}
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function fetchRiskAssessmentPieChartStats(token, filter){
    try {
        const response = await fetch(`${server_ip}/api/riskAssessments/statistic`,{
            method:'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',  
                Authorization: `Bearer ${token}`,    
 
            },
            body: JSON.stringify({
                "filter":{...filter},
                "options":{}
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function fetchUsersRiskAssessmentRole(token, projectId){
    try {
        const response = await fetch(`${server_ip}/api/users/role/risk-assessment`,{
            method:'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',  
                Authorization: `Bearer ${token}`,    
 
            },
            body: JSON.stringify({
                "projectId": projectId
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
export{
    postRiskAssessmentTemplateData,
    postRiskAssessmentTemplateDocument,
    fetchRiskAssessmentTemplateList,
    postCreateRiskAssessment,
    fetchRiskAssessment,
    putRiskAssessmentTemplateData,
    postRiskAssessmentHistory,
    fetchRiskAssessmentHistory,
    putEditRiskAssessment,
    deleteRiskAssessment,
    deleteRiskAssessmentTemplate,
    fetchRiskAssessmentById,
    fetchRiskAssessmentPieChartStats,
    fetchUsersRiskAssessmentRole,
    
}